<template>
  <div>
    <b-navbar class="justify-content-center">
      <b-navbar-brand to="/">マダミスルーム(α)</b-navbar-brand>
    </b-navbar>
    <div class="d-flex flex-column align-items-center">
      <div>アカウントが必要です。作成してログインしよう</div>
      <amplify-authenticator :authConfig="authConfig"></amplify-authenticator>
      <div class="container">
        <div class="d-flex flex-column align-items-center mt-4">
          <span>マーダーミステリー用ツールです。zoomなどと併用して、ネット上でマーダーミステリーを遊ぶときに、若干便利かもしれません。</span>
          <span>今の所カードの移動と、カードを見せる相手を選ぶことができます。</span>

          <strong class="mt-4">使い方</strong>
          <span>1. ゲームを作成して次に部屋を作成する。</span>
          <span>2. 作った部屋のアドレスを遊びたい相手に教える。教えられた人は部屋のアドレスにアクセスして、参加申請を行う。</span>
          <span>3. 部屋を作った人が、参加申請を承認する。zoomなどと併用しながら遊ぶ。</span>
          <span>注意: モックアップのため、後のアップデートで登録したデータが消えることがあります。</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      authConfig: {
        usernameAttributes: "Email",
        signUpConfig: {
          header: "ユーザー登録",
          hideAllDefaults: true,
          defaultCountryCode: "1",
          signUpFields: [
            {
              label: "Email",
              key: "username",
              required: true,
              displayOrder: 1,
              type: "string"
            },
            {
              label: "Password",
              key: "password",
              required: true,
              displayOrder: 2,
              type: "password"
            }
          ]
        }
      }
    };
  }
};
</script>
